// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"338d21f7","71":"c07512ee","123":"a69200da","143":"0f1090a0","159":"10f19523","495":"9b35f9a8","669":"e2040417","940":"40b9409a","944":"4f877175"}[chunkId] + ".chunk.js";
};